import React from "react";

import { PageHeader } from "../layouts/PageHeader";
import { DurableLogo } from "../components/shared/DurableLogo";
import { Link } from "react-router-dom";

/**
 * A simple 404 page to capture mistaken navigation from inside React
 */
function PageNotFound() {
  return (
    <div>
      <PageHeader
        title="404 - Page not found"
        description="The url you entered does not go to a valid page."
        visible={false}
      />
      <div className="w-full flex flex-col justify-center items-center">
        <DurableLogo variant="dynamic" type="logo" />
        <div className="text-4xl mt-12">404 - Not Found</div>
        <div className="text-lg max-w-2xl mt-5 text-center">
          The page you are trying to access does not exist. Please check your
          spelling or&nbsp;
          <Link to="/app/start" className="text-durableTealDark-300">
            return to Start
          </Link>
          .
        </div>
      </div>
    </div>
  );
}

export default PageNotFound;
